export enum FileDownloadType {
    ANNEXE_5 = "ANNEXE_5",
    CALC_REPORTS = "CALC_REPORTS", 
    VCFS_PAYMENT_REPORT = "VCFS_PAYMENT_REPORT", 
    VCFS_ACCOUNTING_REPORT = "VCFS_ACCOUNTING_REPORT"
}
export const FileDownloadTypeKeys: (keyof typeof FileDownloadType)[] = [
  "ANNEXE_5",
  "CALC_REPORTS",
  "VCFS_PAYMENT_REPORT",
  "VCFS_ACCOUNTING_REPORT"
];